<template>
  <sys-dialog
    v-model="dialog_ativo"
    titulo="Tipo de relatório"
    largura="500"
    ocultar-acoes
  >
    <div class="pt-3 pb-8 d-flex align-center">
      <SysRelatoriosCompra
        v-model="relatorio_selecionado"
        return-object
        outlined
        height="10"
        clearable
        class="mb-n8"
        :error-messages="relatorioError"
        :pedido_compra="pedido"
        style="width: 100%"
        @input="$v.relatorio_selecionado.$touch()"
        @blur="$v.relatorio_selecionado.$touch()"
        @relatorio-gerado="fecharDialog()"
      />

      <v-btn large color="primary" class="ml-3" @click="validaRelatorio">
        Gerar
      </v-btn>
    </div>
  </sys-dialog>
</template>

<script>
import SysDialog from "../padraoDeLayout/SysDialog";
import SysRelatoriosCompra from "../utils/crud/SysRelatoriosCompra";
import { required } from "vuelidate/lib/validators";
import $axios from './../../api/api.js';
import {mapGetters} from "vuex";

export default {
  name: "RelatoriosDeExportacao",
  components: {
    SysRelatoriosCompra,
    SysDialog
  },
  model: {
    prop: "valor_modelo",
    event: "atualizacao:valor_modelo"
  },
  props: {
    valor_modelo: {
      type: Boolean,
      required: true
    },
    pedido: Object
  },
  data: () => ({
    relatorio_selecionado: {}
  }),
  validations: {
    relatorio_selecionado: {
      required
    }
  },
  computed: {
    dialog_ativo: {
      get: function () {
        return this.valor_modelo;
      },
      set: function (novo_valor) {
        this.$emit("atualizacao:valor_modelo", novo_valor);
      }
    },
    relatorioError() {
      const errors = [];
      if (!this.$v.relatorio_selecionado.$dirty) return errors;
      !this.$v.relatorio_selecionado.required &&
      errors.push("Campo Obrigatório.");
      return errors;
    },
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
  },
  watch: {
    dialog_ativo() {
      this.$v.$reset();

      if (!this.dialog_ativo) {
        this.relatorio_selecionado = {};
      }
    }
  },
  methods: {
    validaRelatorio() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.gerarRelatorio();
      this.fecharDialog();
    },
    gerarRelatorio () {
      const {src_aplicativo} = this.relatorio_selecionado;

      let parametros = `pedido=${this.pedido.idpedido}`
        + `&grupo=${this.grupoCompra}`
        + `&usuario=${localStorage.getItem("nome")}`
        + `&id_usuario=${localStorage.getItem("id")}`
        + "&systock=grupo";

      const url = `${$axios.defaults.baseURL}/${src_aplicativo}?${parametros}`;
      window.open(url, "_blank");
    },
    fecharDialog() {
      this.$v.$reset();
      this.dialog_ativo = false;
      this.relatorio_selecionado = {};
    }
  }
}
</script>

<style scoped>

</style>
